import * as React from 'react';

import { Panel } from '@ixicare/ui';
import SiteSettingsFormContainer from '../containers/SiteForm';

const SiteCreatePage = () => (
  <Panel>
    <Panel.Title>Create Site</Panel.Title>
    <SiteSettingsFormContainer />
  </Panel>
);

export default SiteCreatePage;
